<template>
  <v-row class="IdentityCheckingIDFileInput">
    <v-col cols="auto" sm="auto" class="d-flex align-center">
      <!-- Choose file -->
      <app-button :id="describedby"
                  class="mr-2"
                  :disabled="disableFileInput"
                  type="outlined"
                  variant="neutral"
                  @click="openFileInput"
      >
        {{ $t('common.identity-checking.IdentityCheckingID.importDocument.chooseFile') }}
      </app-button>
      <AppFileInput :ref="refValue"
                    v-model="file"
                    class="d-none"
                    :aria-describedby="describedby"
                    :accept="allowedExtensions"
                    :error-messages="errors"
                    prepend-icon=""
      />
    </v-col>
    <v-col cols="auto" sm="auto" class="d-flex align-center">
      <!-- File name -->
      <div v-if="file"
            :class="{ 'file-control-errors': isDocumentErrored, 'disabled-file-input': disableFileInput }"
            class="imported-file text-truncate"
      >
        <div class="text-truncate">{{ file.name }}</div>
        <app-button class="mx-2"
                    :disabled="disableFileInput"
                    type="icon"
                    @click="file = null"
        >
          <app-material-icon name="close" />
        </app-button>
      </div>
      <!-- No file -->
      <div v-else :class="{ 'disabled-file-input': disableFileInput }"
                  class="text-text-placeholder"
      >
        {{ $t('common.identity-checking.IdentityCheckingID.importDocument.noFilesSelected') }}
      </div>
    </v-col>
  </v-row>
</template>

<script>
  import AppFileInput from '@/common/AppFileInput.vue'

  export default {
    name: 'IdentityCheckingIDFileInput',
    components: { AppFileInput },
    props: {
      refValue: {
        type: String,
        required: true,
      },
      describedby: {
        type: String,
        required: true,
      },
      allowedExtensions: {
        required: true,
        validator: (value) => {
          return typeof value === 'string' || typeof value === 'object'
        },
      },
      existingFile: {
        type: File,
        default: () => {},
      },
      disableFileInput: {
        type: Boolean,
        default: false,
      },
      isDocumentErrored: {
        type: Boolean,
        default: false,
      },
      errors: {
        type: Array,
        default: () => [],
      },
    },
    data () {
      return {
        file: null,
      }
    },
    watch: {
      file (value) {
        this.$emit('update-file', value)
      },
    },
    created () {
      if (this.existingFile) {
        this.file = this.existingFile
      }
    },
    methods: {
      openFileInput () {
        this.$refs[this.refValue].$refs.fileInput.$el.querySelector('input').click()
      },
    },
  }
</script>

<style scoped lang="scss">
  .IdentityCheckingIDFileInput {
    .imported-file {
      display: inline-flex;
      align-items: center;
      padding-left: 16px;
      border-radius: 4px;
      color: rgb(var(--v-theme-text-grey));
      border: 1px solid rgb(var(--v-theme-border-grey));
      background: rgb(var(--v-theme-surface-grey-subtle));
    }

    .file-control-errors {
      border-color: rgb(var(--v-theme-text-danger));
    }

    .disabled-file-input {
      pointer-events: none;
      color: rgb(var(--v-theme-text-disabled));
    }
  }
</style>
